import CONSTANTES from "../constantes";

export const reducerOrdenes = (state={ordenes:[],total:0}, action) => {
    switch (action.type) {
      case CONSTANTES.PUT_ORDENES:
              return { ...state, ordenes: action.ordenes, total:action.total}
      case CONSTANTES.FILTRO_ORDENES:
            const result = state.ordenes.filter(orden => orden.numerodeorden===action.filter );
            return { ...state, ordenes:[...result]}

      case CONSTANTES.PUT_ORDEN:
            return { ...state, orden: action.orden}
      case CONSTANTES.PUT_DETAIL_ORDEN:
            return { ...state, ordenDetail: action.orden}
      case CONSTANTES.PUT_REVISAR_ORDEN:
              let id = action.orden.id
              let indexOrden = state.ordenes.findIndex(item => item.id === id)
              state.ordenes.splice(indexOrden, 1, action.orden)
            return { ...state, ordenes: [...state.ordenes] }
      case CONSTANTES.OBTENER_HISTORIAL_ORDEN:
            return { ...state, historial: action.historial}
      default:   
        return state
    }
  }